export const DEMO_REQUEST_REPORT = {
  headline: 'Tomás Rivera · Helix Freight — deal created',
  status: 'done',
  durationSec: 41,
  body: `**New demo request from Tomás Rivera, VP Operations at Helix Freight** — deal created in HubSpot.

- **Asked for:** a demo for their 12-person ops team, who currently stitch reports together in spreadsheets.
- **Company:** about 300 employees, logistics, Series B.
- **HubSpot:** new contact and deal *Helix Freight — Ops analytics* in Discovery ($36,000 estimated).
- **Slack:** summary posted to #sales.

**Draft reply** (in your Gmail drafts):

> Hi Tomás — thanks for reaching out. Happy to show you how teams like yours replace the spreadsheet shuffle. Would Tuesday 11:00, Wednesday 15:30, or Thursday 10:00 work for 30 minutes?`,
}
